import React from "react";
import { Create, SimpleForm, TextField } from "react-admin";

const GamePlayerCreate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextField source="sportCode" />
      </SimpleForm>
    </Create>
  );
};

export default GamePlayerCreate;
